import { API_URL } from "config";
import Http from "util/https";
import { UploadMstMainParam, UploadMstMainResponseApi } from "../types";

/**
 * 注文依頼更新CSV確認Api
 * @param params 注文依頼更新CSV確認Apiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function uploadCsvApi(params: UploadMstMainParam) {
  console.log("params:", {...params, upload_kind: 1});
  const http = Http.default.alterAuth({useToken: true, useFormData: true});
  const url = `${API_URL}/general/master/csv/upload`;
  const res = await http.post<UploadMstMainResponseApi>(url, Http.convertObjectToFormData(params));

  console.log(res.data);
  return {
    isError: res.data.errors && res.data.errors > 0,
    data: res.data
  }
}
